import { betaDirectionAPI, courseAPI } from "@/api";

export interface FetchAdditionalSettingsParams {
    directionId: string | number;
}

export interface groupName {
    id: number;
    name: string;
    suffix_type: null | string;
}
export interface AdditionalSettingsResponseData {
    max_students: number;
    random_group_names_in_course: boolean;
    groups_names: Array<groupName>;
}
interface AdditionalSettingsResponse {
    status: string;
    data: AdditionalSettingsResponseData;
}

export const fetchAdditionalSettings = async (
    params: FetchAdditionalSettingsParams = { directionId: '' }
): Promise<AdditionalSettingsResponse | undefined> => {
    try {
        const response = await courseAPI.getAdditionalSettings({ direction_id: params.directionId });
        return response?.data;
    } catch (error) {
        console.error('Ошибка при получении дополнительных настроек:', error);
        throw error;
    }
};